import { calculateDailyStats } from 'pages/trading/price/CalculateDailyStats';
import { PriceChange } from 'pages/trading/model';
import { Matrix } from 'pages/trading/price/promotion/PricePromotionDetailPage';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { calcGrowth } from 'utils/calc';

export function transformData(data: PriceChange[]) {
  const totals = {
    old: { gmv: 0, qty: 0 },
    promo: { gmv: 0, qty: 0, priceDeltaSum: 0 },
    new: { gmv: 0, qty: 0, priceDeltaSum: 0 },
  };

  const matrix: Matrix = {
    priceChange: {
      title: 'priceChange',
      unit: MeasureUnitCode.CURRENCY,
      before: { value: 0 },
      promotion: { value: 0 },
      after: { value: 0 },
    },
    itemsPerDay: {
      title: 'itemsPerDay',
      unit: MeasureUnitCode.QUANTITY,
      before: { value: 0 },
      promotion: { value: 0, comparisonValue: 0 },
      after: { value: 0, comparisonValue: 0 },
    },
    gmvPerDay: {
      title: 'gmvPerDay',
      unit: MeasureUnitCode.CURRENCY,
      before: { value: 0 },
      promotion: { value: 0, comparisonValue: 0 },
      after: { value: 0, comparisonValue: 0 },
    },
  };

  data.forEach(row => {
    const oldStats = calculateDailyStats(row.fromPrice);
    const promoStats = calculateDailyStats(row.promotionPrice);
    const newStats = calculateDailyStats(row.toPrice);

    matrix.priceChange.before.value += oldStats.price;
    matrix.priceChange.promotion.value += promoStats.price;
    matrix.priceChange.after.value += newStats.price;

    matrix.itemsPerDay.before.value += oldStats.dailyQty;
    matrix.itemsPerDay.promotion.value += promoStats.dailyQty;
    matrix.itemsPerDay.after.value += newStats.dailyQty;

    matrix.gmvPerDay.before.value += oldStats.dailyGmv;
    matrix.gmvPerDay.promotion.value += promoStats.dailyGmv;
    matrix.gmvPerDay.after.value += newStats.dailyGmv;

    totals.old.gmv += oldStats.dailyGmv;
    totals.old.qty += oldStats.dailyQty;

    totals.promo.gmv += promoStats.dailyGmv;
    totals.promo.qty += promoStats.dailyQty;
    totals.promo.priceDeltaSum += calcGrowth(promoStats.price, oldStats.price);

    totals.new.gmv += newStats.dailyGmv;
    totals.new.qty += newStats.dailyQty;
    totals.new.priceDeltaSum += calcGrowth(newStats.price, oldStats.price);
  });

  matrix.priceChange.promotion.value = calcGrowth(matrix.priceChange.promotion.value, matrix.priceChange.before.value);
  matrix.priceChange.after.value = calcGrowth(matrix.priceChange.after.value, matrix.priceChange.before.value);
  matrix.priceChange.before.value = 0;

  matrix.itemsPerDay.promotion.comparisonValue = matrix.itemsPerDay.before.value;
  matrix.itemsPerDay.after.comparisonValue = matrix.itemsPerDay.before.value;

  matrix.gmvPerDay.promotion.comparisonValue = matrix.gmvPerDay.before.value;
  matrix.gmvPerDay.after.comparisonValue = matrix.gmvPerDay.before.value;

  const count = data.length || 1;

  return {
    matrix: matrix,
    promo: {
      qty: totals.promo.qty,
      qtyDelta: calcGrowth(totals.promo.qty, totals.old.qty),
      gmv: totals.promo.gmv,
      gmvDelta: calcGrowth(totals.promo.gmv, totals.old.gmv),
      avgPriceChange: totals.promo.priceDeltaSum / count / 100,
    },
    new: {
      qty: totals.new.qty,
      qtyDelta: calcGrowth(totals.new.qty, totals.old.qty),
      gmv: totals.new.gmv,
      gmvDelta: calcGrowth(totals.new.gmv, totals.old.gmv),
      avgPriceChange: totals.new.priceDeltaSum / count / 100,
    },
  };
}
